/**
 * This is the logo of Taxpeeer <3
 * It is used to display the logo
 * @param width - The width of the logo.
 * @returns The logo of the application.
 */
export function TaxpeerLogo({ width = 150 }: { width?: number }) {
	return (
		<div className="flex p-2 flex-col items-center">
			<img width={width} src="/taxpeer-logo.svg" alt="Taxpeer Logo" />
		</div>
	);
}
